import React, { useState } from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle, defaultProjectHash, urlWebsite } from '../../../../../../config';
import { FaLink, FaList, FaMoneyBill, FaReceipt, FaTable, FaTicketAlt, FaUser } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

import { Form } from '@unform/web';
import Input from '../../../../core/components/Forms/Input';
import { useModal } from '../../../../../../hooks/Modal';
import { useSearch } from '../../../../../../hooks/Search';
import CopyToClipboard from '../../../../core/components/CopyToClipboard';
import WhatsappCompartilhar from '../../../../../../components/WhatsAppCompartilhar';
import WhatsappCompartilharSimple from '../../../../../../components/WhatsAppCompartilharSimple';
import { getDay } from 'date-fns';

interface ICreateModule {
    lineData: Record<string, any>;
}

export const VisualizarParticipantes: React.FC<ICreateModule> = ({ lineData }) => {

    const { projectHash = defaultProjectHash } = useParams<Record<string, any>>();
    const { addToast } = useToast();
    const { addModal, removeModal } = useModal();
    const { reloadSearchAll } = useSearch();




    const listar = async (data) => {

        try {
            const credenciamentos = await api.get(`/credenciamento`, { params: { limitItems: 10000, where: { room_id: lineData?.company } } });

            const notUsed = credenciamentos?.data?.rows?.filter(item => !item?.client_id);

            const used = credenciamentos?.data?.rows?.filter(item => item?.client_id);

            const items: Record<string, any>[] = [];

            used?.map(i => {

                const index = items?.findIndex((cred: any) => cred?.client_id === i?.client_id && getDay(cred?.createdAt) === getDay(i?.createdAt));
                if (index < 0) {
                    items.push(i);
                }

            })

            addModal({
                theme: 'whiteModal', key: "modal", title: ' ', content: <>
                    <h2 style={{ color: '#333', fontSize: '16px' }}>Códigos gerados: {items?.length + notUsed?.length} | Utilizados: {items?.length} | Não utilizados: {notUsed?.length}</h2>
                    <table className='tableRef'>
                        <tbody>
                            {items?.map(item => {
                                return <tr  ><td>

                                    {lineData?.name}
                                </td>

                                    <td>
                                        {item?.name}
                                    </td>
                                    <td>
                                        {item?.email}
                                    </td>
                                    <td>
                                        {item?.createdAt}
                                    </td>
                                </tr>

                            })}

                        </tbody>
                    </table>

                </>
            })


        }
        catch (err) {
            addToast({ title: err?.response?.data?.message || err?.response?.data?.error || 'Erro ao verificar', type: 'error' })
        }




    }



    const moduleUpdate = (): JSX.Element => (
        <> <button title='Lista de acessos' className="lineIcon" type="button" onClick={listar}>
            <FaList />
        </button>

        </>

    );

    return moduleUpdate();
}
export default VisualizarParticipantes;